import type { ComponentType } from 'react'
import { Monitor, Moon, Sun } from 'lucide-react'
import { syncThemeToStorage } from '../hooks/useThemeEffect'

export type Theme = 'light' | 'dark' | 'system'

export const THEME_OPTIONS: { value: Theme; label: string; icon: ComponentType<{ className?: string }> }[] = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
]

export function applyThemeSelection(theme: Theme) {
  syncThemeToStorage(theme)
  const resolved = theme === 'system'
    ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    : theme
  document.documentElement.classList.remove('light', 'dark')
  document.documentElement.classList.add(resolved)
}
